import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import AddAgreement from './AddAgreement';
import ListAgreements from './ListAgreements';
import ShowAgreement from './ShowAgreement/ShowAgreement.container';
import UpdateAgreement from './UpdateAgreement';

function Routes() {
  return (
    <DocumentTitle title="Agreements">
      <Route path="/agreements" exact component={ListAgreements} />
      <Route path="/agreements/add" component={AddAgreement} />
      <Route path="/agreements/:id/show" component={ShowAgreement} />
      <Route path="/agreements/:id/edit" component={UpdateAgreement} />
    </DocumentTitle>
  );
}

export default Routes;
